import slotPositionsConfig from './slot-positions-config.json';

const TOO_BIG_POSITION = 1000000000;

export default function slotTypePositionCalculator(sportId, groupType, slot) {
    const slotType = slot.type;

    //slotType => position
    let slotPositions = slotPositionsConfig[sportId][groupType];

    if (slotPositions == undefined) {
        return TOO_BIG_POSITION;
    }

    return slotPositions[slotType] * 10000 || TOO_BIG_POSITION;
}




// WEBPACK FOOTER //
// ./js/sport-betting/components/grid-control/slot-arrangement-policies/positionCalculators/SlotTypePositionCalculator.js